import { Box } from '@packages/shared';
import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import { CmsComponents } from '@packages/cms-components/src/components';
import { registerFlexibleComponents } from '@packages/cms-components/src/components/ComponentRecognizer/registerFlexibleComponents';

// register the dynamic components
registerFlexibleComponents();

export type ContentExternalProps = {
  /** initial json data used to render cms content */
  data: CmsData;
};

/**
 * This component displays cms content on SIS pages
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in @apps/shopping pages
 */
export const ContentExternal = ({ data }: ContentExternalProps): JSX.Element =>
  Array.isArray(data.paragraph) && data.paragraph?.length > 0 ? (
    <Box sx={{ m: 0, p: 0 }}>
      <CmsComponents paragraphs={data.paragraph} pageTemplate="sis" />
    </Box>
  ) : (
    <h2>no data</h2>
  );
